<template>
  <div id="app">
    <navbar />
    <router-view />
    <h6 class="mt-5 text-center mb-5">
      <span class="text-light"> iQ Studio - Copyright ©</span> <br>
      <a href="https://iqstudiogt.com/">www.iqstudiogt.com</a>
    </h6>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
export default {
  components: { Navbar }
};
</script>

<style lang="scss">
body {
  background-image: linear-gradient(
      0deg,
      rgba(250, 250, 250, 0.1),
      rgba(14, 0, 51, 0.2)
    ),
    url('/img/bg.jpg');
    // url(https://wallpaperplay.com/walls/full/f/f/a/163485.jpg);
  // background-image: linear-gradient(0deg, rgba(53, 0, 139, 0.3), rgba(0, 0, 0, 0.8)), url(https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/77f1f60f-2b47-4c08-9c95-df986efe8c7f/dd6yq9v-c9929aee-c4c8-4f67-a54f-44a96a49b8a3.png/v1/fill/w_1024,h_576,q_80,strp/visual_novel_background__classroom_by_kjkjmulo_dd6yq9v-fullview.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzc3ZjFmNjBmLTJiNDctNGMwOC05Yzk1LWRmOTg2ZWZlOGM3ZlwvZGQ2eXE5di1jOTkyOWFlZS1jNGM4LTRmNjctYTU0Zi00NGE5NmE0OWI4YTMucG5nIiwiaGVpZ2h0IjoiPD01NzYiLCJ3aWR0aCI6Ijw9MTAyNCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS53YXRlcm1hcmsiXSwid21rIjp7InBhdGgiOiJcL3dtXC83N2YxZjYwZi0yYjQ3LTRjMDgtOWM5NS1kZjk4NmVmZThjN2ZcL2tqa2ptdWxvLTQucG5nIiwib3BhY2l0eSI6OTUsInByb3BvcnRpb25zIjowLjQ1LCJncmF2aXR5IjoiY2VudGVyIn19.tlNsovwcY-weMtUeKVrIOcyOaPdhKWG2SONVOx_dmPE);
  background-size: cover;
  background-attachment: fixed;
}

table {
  background: rgba($color: rgb(11, 10, 14), $alpha: 0.5);
}

td {
  color: #fff;
}

h1,
h2,
h3,h4,h5 {
  text-shadow: 0px 0px 4px rgba($color: #fff, $alpha: 0.3);
  color: #fff;
}

.navbar-collapse .nav-item > a{
  padding-left: 30px !important;
  padding-right: 30px !important;
}
.navbar-collapse .active {
  border: 1px solid;
  border-radius: 30px;
  background-color: rgba($color: #fff, $alpha: 0.2);
  font-weight: 450;  
}

.btn-dark{
  background-color: rgba($color: #000000, $alpha: 0.35) !important;
}

.float-right{color:#fff;}

.page-item.active .page-link{
  border-color: #fff!important;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.page-link{
  background-color: rgba(0, 0, 0, 0.5) !important;
  margin: 2px;
  // border-radius: 10px;
}

</style>
